import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FmPaginatedVideoRoomGenericList extends SnModel {
  @Expose()
  public count: number;
  @Expose()
  public links: [
    {
      next: string;
      previous: string;
    },
  ];

  @Expose()
  public totalPages: number;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
